import React, { useEffect } from 'react';

export default function MessageBox({
  type = 'info',
  message,
  onClose,
  duration = 4000,
}) {
  const colors = {
    error: '#D9534F',
    success: '#1F8F4D',
    info: '#0F3D2E',
  };

  useEffect(() => {
    if (onClose && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [onClose, duration]);

  return (
    <div
      style={{
        padding: '12px 16px',
        backgroundColor: colors[type],
        color: '#fff',
        borderRadius: 8,
        marginBottom: 15,
        fontSize: 14,
        fontWeight: 700,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            marginLeft: 10,
            background: 'transparent',
            border: 'none',
            color: '#fff',
            fontWeight: 900,
            cursor: 'pointer',
          }}>
          x
        </button>
      )}
    </div>
  );
}
